export var VIEW_READY = 'VIEW_READY';
export var SHARED_COLOR = 'SHARED_COLOR';
